import React, { useState } from "react";
import { Fragment } from "react";
import Navigation from "../Layout/Navigation";
import Footer from "../Layout/Footer";
import BackToTop from "../Reusable/BackToTop";
import { useTranslation } from "react-i18next";

const ThemeWrapper = (props) => {
  const { t } = useTranslation();
  const [showBlock, setShowBlock] = useState(false);

  return (
    <Fragment>
      <Navigation />
      <main className="main main-site-container-shop">
        <div className="container">{props.children}</div>
      </main>
      <Footer />
    </Fragment>
  );
};

export default ThemeWrapper;
